// React.lazy that recovers from a chunk that vanished after a deploy by
// reloading the page once (same guard as chunkRecovery.ts). Use instead of
// `lazy()` for route components.
import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import { isChunkLoadError } from "./chunkReloadGuard";
import { tryReloadForChunkError } from "./chunkRecovery";

export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(() =>
    factory().catch((err: unknown) => {
      if (import.meta.env.PROD && isChunkLoadError(err) && tryReloadForChunkError()) {
        // Reloading: keep the Suspense fallback up instead of an error boundary.
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    }),
  );
}
